// extracted by mini-css-extract-plugin
module.exports = {"page":"main-page__page____zhOi8","tablelink":"main-page__tablelink____3I4d3"};